// Общие для всех запросов профиля тексты ошибок. Используются, только если
// сервер не прислал поле message.
export const PROFILE_FALLBACK_MESSAGES: Record<number, string> = {
  401: "Authorization required. Please sign in again.",
  404: "User not found.",
};

export const PROFILE_DEFAULT_MESSAGE =
  "Something went wrong. Please try again.";
